import { LegolandConfig } from './LegolandConfig';

export const productionConfig: Readonly<LegolandConfig> = {
  authApiUrl: 'https://auth.move.tomtom.com',
  legolandApiUrl: 'https://api.move.tomtom.com',
  legolandUiUrl: 'https://move.tomtom.com',
};
